import { render, staticRenderFns } from "./InventoryAvailability.vue?vue&type=template&id=2760333d&scoped=true"
import script from "./InventoryAvailability.vue?vue&type=script&lang=js"
export * from "./InventoryAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760333d",
  null
  
)

export default component.exports